<template>
    <comp-9-art-adherence :section="9" :page="72">
        <p class="headline text-xs-center">Let’s Review</p>
        <p>
            We have learned a lot in this activity, like that you’re committed to doing what you can to protect your health and that taking ART is important to
            you because:
        </p>
        <ul>
            <li v-for="motivator in artChangeMotivators" :key="motivator.id">{{ motivator.userEntered ? motivator.response : motivator.text }}</li>
        </ul>
        <br />
        <p>
            We were reminded that taking ART everyday is the most reliable way to protect our own health and partners when having sex. In order to support you
            taking ART everyday, we identified strategies that can help remind you to take your ART. These strategies include:
        </p>
        <ul>
            <li v-for="strategy in artStrategies" :key="strategy.id">{{ strategy.userEntered ? strategy.response : strategy.text }}</li>
        </ul>
        <br />
        <p>
            Yassss! You’ve got it. I believe in you!
        </p>
        <div v-if="!prepVisited">
            <p>Do you want to visit the PrEP adherence resources?</p>
            <v-layout row wrap justify-center my-3>
                <v-flex xs6>
                    <div @click.prevent="viewPrep()" class="diagram-chip fact">
                        <v-chip color="primary" text-color="white" class="py-2" v-ripple>PrEP Resources</v-chip>
                        <div class="check" v-if="prepVisited">
                            <v-avatar class="success">
                                <v-icon dark>check</v-icon>
                            </v-avatar>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </div>
    </comp-9-art-adherence>
</template>

<script>
import { get } from 'vuex-pathify';
import { filter } from 'lodash';
import router from '@/router';

export default {
    computed: {
        artChangeMotivators() {
            return filter(this.$store.get('section9/artMotivatorsRevisited'), 'selected');
        },
        artStrategies() {
            return filter(this.$store.get('section9/artRegularStrategiesRevisited'), 'selected');
        },
        prepVisited: get('section9/prepVisited'),
        firstPrepScreen: get('section9/firstPrepScreen')
    },
    methods: {
        viewPrep() {
            // go to the first PrEP Adherence screen
            router.push(`/page/9/${this.firstPrepScreen}`);
        }
    }
};
</script>

<style scoped>
.fact {
    position: relative;
}
.check {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
}
.visited {
    opacity: 0.5;
}
</style>
